import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: '首页',
		component: () => import('./views/Home.vue'),
	},
	{
		path: '/home',
		name: '首页',
		component: () => import('./views/Home.vue')
	},
  {
    path: '/barrageGame',
    name: '彈幕遊戲',
    component: () => import('./views/barrageGame.vue')
  },
	{
		path: '/partners',
		name: '合作廠商',
		component: () => import('./views/Partners.vue')
	},
	{
		path: '/memberCenter',
		name: '会员中心',
		component: () => import('./views/MemberCenter.vue')
	},
	{
		path: '/gameStoreCenter',
		name: '储值中心',
		meta: {
			requireAuth: true,
		},
		component: () => import('./views/StoreCentrer.vue')
	},
	{
		path: '/customerCenter',
		name: '客服中心',
		component: () => import('./views/CustomerCenter.vue')
	}
]

const router = new VueRouter({
	// 路径不加#号,将 mode 设置为'history' 即可. 默认情况是'hash' 所以会有 #
	// mode: 'history',
	routes,
	linkExactActiveClass: 'current',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

export default router
